/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'

// 创建axios实例
const instance = axios.create({
  // baseURL: 'http://192.168.80.102:44387/',
  // timeout: 10000,
  // headers: {
  //   post: {
  //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  //   }
  // }
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    // token && (config.headers.Authorization = token)
    return config
  },
  (error) => {
    const err = [error, null]
    return Promise.resolve(err)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 204) {
      return Promise.resolve([null, response.data])
    }
    const err = [response.data.error.message, null]
    return Promise.resolve(err)
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          console.log('401')
          break
          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
        case 403:
          break
          // 404请求不存在
        case 404:
          app.$message.error('请求的资源不存在')
          break
          // 其他错误，直接抛出错误提示
        default:
      }
      const data = error.response.data || {}
      const err = [data.message || (data.error && data.error.message) || '未知错误', null]
      app.$message.error(data.message || (data.error && data.error.message) || '未知错误')
      return Promise.resolve(err)
    }
    const err = [error, null]
    return Promise.resolve(err)
  }
)

export default instance
